import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
// import { widthPercentageToDP as wp, heightPercentageToDP as hp, listenOrientationChange as loc, removeOrientationListener as rol } from '../../utils/ScreenInfo';



export class ResponsiveWrapper extends Component {
  render() {
    return (
        <View style={styles.container}>
            <View style={[styles.responsiveBox, this.props.maxWidth ? { maxWidth: this.props.maxWidth } : undefined]}>
                {this.props.children}
            </View>
        </View>
    );
  }
}





const styles = StyleSheet.create({
    container: {
        flex: 1,
        // backgroundColor: 'gray',
        alignItems: 'center',
        justifyContent: 'center',
    },
    responsiveBox: {
        // width: wp('84.5%'),
        width: '100%',
        // height: hp('17%'),
        // borderWidth: 2,
        // borderColor: 'orange',
        maxWidth: 1000,
        flexDirection: 'column',
        justifyContent: 'space-around',
        // justifyContent: 'space-around',
    }
});

export const RESPONSIVE_STYLES = styles;